import { Link } from "react-router-dom";

const DIRECTIONS_URL =
  "https://www.google.com/maps/search/?api=1&query=Area%2083%2C%20Off%20Bannerghatta%20Road%2C%20Bengaluru%2C%20Karnataka%20560083";

export const Footer = () => (
  <footer data-testid="footer" className="grain bg-brand-licorice pb-10 pt-16 text-brand-ivory/70">
    <div className="mx-auto max-w-7xl px-6 sm:px-8">
      <div className="grid gap-12 border-b border-brand-ivory/10 pb-14 md:grid-cols-12">
        <div className="md:col-span-5">
          <img src="/images/dune-villas-white.png" alt="Dune Villas" className="h-5 w-auto" data-testid="footer-logo" />
          <p className="mt-6 max-w-sm text-sm leading-relaxed">
            Dune Villas, the most premium stay at Area 83. Private six-bedroom villas made for families, celebrations
            and time well spent together.
          </p>
          <Link to="/" data-testid="footer-parent-brand" className="mt-8 inline-flex items-center gap-3 text-[11px] uppercase tracking-[0.18em] text-brand-ivory/50 transition-opacity hover:opacity-70">
            part of <img src="/images/erth-white.png" alt="erth. escapes" className="h-7 w-auto" />
          </Link>
        </div>
        <div className="md:col-span-4">
          <p className="mb-5 text-[11px] font-semibold uppercase tracking-[0.24em] text-brand-champagne">Contact</p>
          <ul className="flex flex-col gap-3 text-sm">
            <li>
              <a href="tel:+918046396067" data-testid="footer-phone" className="transition-opacity hover:opacity-60">
                +91 80463 96067 <span className="text-brand-ivory/40">· Reservations</span>
              </a>
            </li>
            <li>
              <a href="tel:+918884608383" data-testid="footer-support" className="transition-opacity hover:opacity-60">
                +91 88846 08383 <span className="text-brand-ivory/40">· Support (10 AM to 8 PM)</span>
              </a>
            </li>
            <li>
              <a href="mailto:info@area83.in" data-testid="footer-email" className="transition-opacity hover:opacity-60">
                info@area83.in
              </a>
            </li>
            <li className="leading-relaxed">
              No. 313, Off Bannerghatta Road, Bilwaradahalli, Shanbhoganahalli, Bengaluru, Karnataka 560083
            </li>
            <li>
              <a
                href={DIRECTIONS_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-directions"
                className="text-brand-champagne underline underline-offset-4 transition-opacity hover:opacity-60"
              >
                Get directions
              </a>
            </li>
          </ul>
        </div>
        <div className="md:col-span-3">
          <p className="mb-5 text-[11px] font-semibold uppercase tracking-[0.24em] text-brand-champagne">Explore</p>
          <ul className="flex flex-col gap-3 text-sm">
            <li><a href="#villas" data-testid="footer-link-villas" className="transition-opacity hover:opacity-60">The Villas</a></li>
            <li><a href="#gallery" data-testid="footer-link-gallery" className="transition-opacity hover:opacity-60">Gallery</a></li>
            <li><a href="#faqs" data-testid="footer-link-faqs" className="transition-opacity hover:opacity-60">FAQs</a></li>
            <li><Link to="/journal" data-testid="footer-link-journal" className="transition-opacity hover:opacity-60">Journal</Link></li>
            <li><a href="#location" data-testid="footer-link-location" className="transition-opacity hover:opacity-60">Location</a></li>
            <li><Link to="/" data-testid="footer-link-erth" className="transition-opacity hover:opacity-60">erth. escapes</Link></li>
            <li>
              <a href="https://www.area83.in/" target="_blank" rel="noopener noreferrer" data-testid="footer-link-area83" className="transition-opacity hover:opacity-60">
                Area 83 main website
              </a>
            </li>
            <li>
              <a href="https://www.area83.in/terms-and-conditions" target="_blank" rel="noopener noreferrer" data-testid="footer-link-terms" className="transition-opacity hover:opacity-60">
                Terms & Conditions
              </a>
            </li>
            <li>
              <a href="https://www.area83.in/privacy-policy" target="_blank" rel="noopener noreferrer" data-testid="footer-link-privacy" className="transition-opacity hover:opacity-60">
                Privacy Policy
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="flex flex-col justify-between gap-3 pt-8 text-xs text-brand-ivory/40 sm:flex-row sm:items-center">
        <p>© 2026 Dune Villas at Area 83. Part of erth. escapes.</p>
        <p>A private villa stay, a short drive from the city.</p>
      </div>
    </div>
  </footer>
);
